/**
 * The template target a studio form describes (`@acp/engine/templates.js`):
 * the simulators on a host and port block, or one vMix on its host and TCP
 * API port — or null while a field is not filled in right. One rule for the
 * "New studio" dialog and the onboarding wizard's studio step. Pure.
 */
import type { TemplateKind, TemplateTarget } from '@acp/engine/templates.js';

/** A port block: the simulators listen on base + 5, 6, 7, so it leaves room for them. */
export function basePortOf(text: string): number | null {
  const n = Number(text);
  return text.trim() !== '' && Number.isInteger(n) && n > 0 && n < 65_530 ? n : null;
}

/** A single TCP port (vMix's API): the whole range. */
export function tcpPortOf(text: string): number | null {
  const n = Number(text);
  return text.trim() !== '' && Number.isInteger(n) && n > 0 && n <= 65_535 ? n : null;
}

export function templateTargetOf(kind: TemplateKind, host: string, port: string): TemplateTarget | null {
  if (host.trim() === '') return null;
  if (kind === 'sim') {
    const basePort = basePortOf(port);
    return basePort === null ? null : { kind, host: host.trim(), basePort };
  }
  const tcp = tcpPortOf(port);
  return tcp === null ? null : { kind, host: host.trim(), port: tcp };
}
